<template> 
  <title-tab
    :msg="msg"
    :img-src="src"
  >  
    <slot />
    <v-card  
      v-if="items.length!==0"
      class="toolbartab"
      flat
      tile
    >
      <v-row
        no-gutters
      >
        <v-col
          v-for="(item,i) in items"
          :key="i"
          class="pa-2"
          cols="6"
          sm="3"
          md="2"
          lg="2"
        >
          <v-card
            :disabled="item.is_closed"
            class="toolbartab"
            router
            @click="gotoExternalGame(item.id,item.name)"
          > 
            <v-img 
              :src="item.image_url"
              width="100%"
              height="100%"
              aspect-ratio="1"
            /> 
            <v-btn
              class="white--text game-name"
              outlined
              width="100%"
            >
              {{ item.name }}
            </v-btn>
          </v-card>
        </v-col>
      </v-row> 
    </v-card>    
  </title-tab>  
</template>
<script> 
import { service as apiExternal } from '@/apis'       
import { IsInternalApp } from '@/plugins/checkType'
import { externalGamePath } from '@/plugins/mapImage'
import { ROUTE_POWER_BALL } from '@/const/route'
import { isGameTypeIdSeamless } from '@/const/gameId'

const OTHER_GAME_CATE_ID = 5
export default { 
  props : {
    msg : {
      type : String,
      default : ''
    }, 

    typeGame : {
      type : Number,
      default : 0
    }, 

    src : {
      type : String,
      default : ''
    }
  },  

  computed: {
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },

    externalGame () {
      return this.$store.getters['externalGame/GETTERS_EXTERNALGAME']
    },

    items () {
      const externalItems = this.externalGame.filter(x=>x.category_game_type_id === this.typeGame)
      
      let extractedGames = [];

      externalItems.forEach(function (item) {
        var games = item.games.map(function (game) {
          game.is_external = true;

          return game;
        })

         extractedGames = extractedGames.concat(games);
      });

      extractedGames.sort((a, b) => {
        if (a.order_priority !== null && b.order_priority !== null) {
          if (a.order_priority !== b.order_priority) {
              return a.order_priority - b.order_priority;
          }
        } else if (a.order_priority !== null && b.order_priority === null) {
            return -1;
        } else if (a.order_priority === null && b.order_priority !== null) {
            return 1;
        }

        return a.id - b.id;
      });

      return extractedGames;
    }
  },
  
  methods : { 
    externalGamePath,
    async topUp (id) {  
      if(isGameTypeIdSeamless(id)) {
        return
      }
      const [err] = await apiExternal.postTransfer(id)
      
      if(err) {
        this.$alert('',err,'warning') 
        return
      } 
    }, 

    isIOS () {
      return /MacIntel/.test(navigator.platform)  && navigator.maxTouchPoints && navigator.maxTouchPoints > 2
    },

    async endpoint (id) {
      let isIpad = this.isIOS()
      return isIpad ? apiExternal.getLoginGameMobile(id) : apiExternal.getLoginGame(id) 
    },

    async gotoExternalGame (id,name) {  
      //by pass and route to power ball path
      if(this.typeGame === OTHER_GAME_CATE_ID) {
        this.$router.push({name: ROUTE_POWER_BALL})
        return
      }
      let windowReference = IsInternalApp() ? window : window.open() ;  

      const [err,data,message] = await this.endpoint(id)
      
      if(err) {
        windowReference.close()
        this.$alert('',err,'warning') 
        return
      }

      if(data && data.redirect_to) {
        // await this.topUp(id) 
        this.$store.dispatch('userProfile/ACTION_WALLET') 
        windowReference.location = data.redirect_to   
      } else {
        windowReference.close()
        this.$alert('',message,'warning')
      }  

      this.$ga.event('Button', 'GotoExternalgame', 'CasinoPage',name )  
    },  
  }
} 
</script> 

<style scoped> 
.game-name {
  overflow: hidden;
}
</style>
